(() => {
  const root = document.querySelector('[data-first-new]');
  if (!root) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = root.querySelectorAll('[data-reveal]');

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    revealItems.forEach((item) => observer.observe(item));
  }

  root.querySelectorAll('[data-delivery-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const modal = document.getElementById('modalArea');
      if (modal) modal.style.display = 'block';
    });
  });
})();
